import React, { useState, useEffect } from "react";
import styles from "./Exchanges.module.css";
import { useNavigate } from "react-router-dom";
import BackButton from "../../BackButton/BackButton";
import CreateLink from "../../ReturnsView/CreateLink";
import ReturnsList from "../../ReturnsView/ReturnsList";
import SelectEligibleProducts from "./SelectEligibleProducts";
import { useFont } from "../../../contexts/FontContext/FontContext";
import UtilityButton from "../../UtilityButton/UtilityButton";
import { highlightOptionBorder } from "../../utils/common";

const Exchanges = ( { setReturnOptionSelected }) => {
	const [exchangesButtonsEnabled, setExchangesButtonsEnabled] = useState(false);
	const [hoveredExchangeOption, setHoveredExchangeOption] = useState(null);
	const [fadeClassEditExchangeForm, setFadeClassEditExchangeForm] = useState("no_opacity");
	const [fadeClassNewExchange, setFadeClassNewExchange] = useState("no_opacity");
	const [fadeClassSeeAllExchanges, setFadeClassSeeAllExchanges] = useState("no_opacity");
	const [exchangeOptionSelected, setExchangeOptionSelected] = useState(null);
	const [exchangesOptionBlurbOpacity, setExchangesOptionBlurbOpacity] = useState({exchange_form: "no_opacity", new_exchange: "no_opacity", see_all_exchanges: "no_opacity"});
	const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one;
    const navigate = useNavigate();

	const fadeInExchangesOptions = () => {  
		//must reset opacity here. Otherwise, animation won't run properly when returns button in navbar is selected.
		setFadeClassEditExchangeForm("no_opacity");
		setFadeClassNewExchange("no_opacity");
		setFadeClassSeeAllExchanges("no_opacity");
		setExchangesButtonsEnabled(false);
		resetExchangesOptionBlurbOpacity();
		setTimeout(() => { setFadeClassEditExchangeForm("fade_in_bounce"); }, 100);
		setTimeout(() => { setFadeClassNewExchange("fade_in_bounce"); }, 400);
		setTimeout(() => { 
			setFadeClassSeeAllExchanges("fade_in_bounce"); 
			setExchangesButtonsEnabled(true);
		}, 600);
	};

	// Reset all blurbs to "no_opacity" when the mouse leaves
	const resetExchangesOptionBlurbOpacity = () => {
		setHoveredExchangeOption(null);
		setExchangesOptionBlurbOpacity({exchange_form: "no_opacity", new_exchange: "no_opacity", see_all_exchanges: "no_opacity"});
	};

	const highlightExchangeOption = (option) => { 
		setHoveredExchangeOption(option);
		setExchangesOptionBlurbOpacity({
			exchange_form: option === "exchange_form" ? "fade_in" : "no_opacity",
			new_exchange: option === "new_exchange" ? "fade_in" : "no_opacity",
			see_all_exchanges: option === "see_all_exchanges" ? "fade_in" : "no_opacity"
		});
	};

	const selectExchangeOption = (option) => { setExchangeOptionSelected(option); };

    // Run fadeInReturnsOptions each time returnOptionSelected is set to null
	useEffect(() => {
		if (exchangeOptionSelected === null) { fadeInExchangesOptions(); }
	}, [exchangeOptionSelected]);
	
	return (
		<div className={styles.exchanges_view_container}>
			{!exchangeOptionSelected && (
				<>
					<p className={`titles ${styles.exchanges_view_title} fade_in ${fontFamilyOne}`}>Select an option.</p>
					<div className={styles.exchanges_options_wrapper}>
						<UtilityButton id="exchange_form_select" imageId={styles.exchange_form_select_image} title="Exchange form" option="exchange_form" imageSrc={`${process.env.PUBLIC_URL}/images/exchange_form.png`} onHover={highlightExchangeOption} onLeave={resetExchangesOptionBlurbOpacity} onClick={selectExchangeOption} fadeClass={fadeClassEditExchangeForm} isSelected={null} isDisabled={!exchangesButtonsEnabled} borderStyle={highlightOptionBorder(hoveredExchangeOption, "exchange_form")}/>
						<UtilityButton id="new_exchange_select" imageId={styles.new_exchange_select_image} title="New exchange" option="new_exchange" imageSrc={`${process.env.PUBLIC_URL}/images/new_exchange.png`} onHover={highlightExchangeOption} onLeave={resetExchangesOptionBlurbOpacity} onClick={selectExchangeOption} fadeClass={fadeClassNewExchange} isSelected={null} isDisabled={!exchangesButtonsEnabled} borderStyle={highlightOptionBorder(hoveredExchangeOption, "new_exchange")}/>
						<UtilityButton id="see_all_exchanges_select" imageId={styles.see_all_exchanges_select_image} title="See all exchanges" option="see_all_exchanges" imageSrc={`${process.env.PUBLIC_URL}/images/see_all_exchanges_image.png`} onHover={highlightExchangeOption} onLeave={resetExchangesOptionBlurbOpacity} onClick={selectExchangeOption} fadeClass={fadeClassSeeAllExchanges} isSelected={null} isDisabled={!exchangesButtonsEnabled} borderStyle={highlightOptionBorder(hoveredExchangeOption, "see_all_exchanges")}/>
					</div>
					<div className={`${fontFamilyOne} ${styles.exchanges_selection_information_wrapper}`}>
						<div className={`${styles.exchanges_blurb_wrapper} ${exchangesOptionBlurbOpacity.exchange_form}`}>
							<p className={`${styles.exchanges_blurbs}`}>Edit your exchange form.</p>
						</div>
						<div className={`${styles.exchanges_blurb_wrapper} ${exchangesOptionBlurbOpacity.new_exchange}`}>
							<p className={`${styles.exchanges_blurbs}`}>Begin an exchange.</p>
						</div>
						<div className={`${styles.exchanges_blurb_wrapper} ${exchangesOptionBlurbOpacity.see_all_exchanges}`}>
							<p className={`${styles.exchanges_blurbs}`}>View or void previous exchanges.</p>
						</div>
					</div>
					<BackButton button_id={styles.exchanges_back_button} image_id={styles.exchanges_back_button_arrow} customBack={() => { setReturnOptionSelected(null); }} />
				</>
			)}
			{exchangeOptionSelected === "exchange_form" && (<SelectEligibleProducts exchangeOptionSelected={exchangeOptionSelected} setExchangeOptionSelected={setExchangeOptionSelected} />)}
			{exchangeOptionSelected === "new_exchange" && (<CreateLink linkType={"exchange"} setExchangeOptionSelected={setExchangeOptionSelected} />)}
			{exchangeOptionSelected === "see_all_exchanges" && (<ReturnsList seeAllExchanges={true} setExchangeOptionSelected={setExchangeOptionSelected} />)}
		</div>
	);
};

export default Exchanges;